import axios from '@/axios'
import Vue from 'vue'

const state = {
  surveys: [],
};

const actions = {
  fetchSurveys({ commit }, config) {
    return axios.get('surveys', config)
      .then((r) => {
        if (r.data.success) {
          commit('SAVE_SURVEYS', r.data.quizzes)
        } else {
          throw new Error("Surveys forbidden");
        }
      })
  }
};

const mutations = {
  SAVE_SURVEYS(state, messages) {
    Vue.set(state, 'surveys', messages);
  },
};

export default {
  state,
  actions,
  mutations
}
